import React from 'react';
import utils from '../../../utils';
import fetch from '../../fetch';
import {Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {key:'assessStatus', label: '评审状态', width: 120, render:(val)=>{
        if(val === 0){
            return <Tag color='#2db7f5'>待分配评审</Tag>
        }else if(val === 1){
            return <Tag color='#1890ff'>待评审</Tag>
        }else if(val === 2){
            return <Tag color='#722ed1'>评审中</Tag>
        }else if(val >= 3){
            return <Tag color='#87d068'>已评审</Tag>
        }
    } },
    {
        key: 'assessScore', width: 100,
        label: '评审分数',
    },
    {
        key: 'masterName', width: 100,
        label: '评审专家'
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    {
        key: 'termName', width: 120,
        label: '所属学期'
    }
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {key:'assessStatus', label: '评审状态', width: 120, render:(val)=>{
        if(val === 0){
            return <Tag color='#2db7f5'>待分配评审</Tag>
        }else if(val === 1){
            return <Tag color='#1890ff'>待评审</Tag>
        }else if(val === 2){
            return <Tag color='#722ed1'>评审中</Tag>
        }else if(val >= 3){
            return <Tag color='#87d068'>已评审</Tag>
        }
    } },
    {
        key: 'assessScore', width: 100,
        label: '评审分数',
    },
    {
        key: 'masterName', width: 100,
        label: '评审专家'
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    {
        key: 'termName', width: 120,
        label: '所属学期'
    }
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    let showExpert = true
    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else if(i === 'showExpert'){
            showExpert = `${keywords[i]}`;
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    return fetch.post('project/expert/total/query?'+ params.join('&'), Object.assign({
    }, defaultsParams, newKeyword))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: (res.data.dataList || []).map(d => {
            return Object.assign({}, d, {
                height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
            })
        }),
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.id,
            checked: false,
            height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const getReviewDetailById = (id) => {
    return fetch.get(`project/expert/total/getDetailById/${id}`)
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch,
    getReviewDetailById
}